/**
 * @fileoverview POST handler for the "/app_settings/:app_group_id/message_prioritization/category" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsAppGroupIdMessagePrioritizationCategoryCacheKeys } from "./constants";
import type { PostMessagePrioritizationCategoryProps, PostMessagePrioritizationCategoryResult } from "./types";

export const postMessagePrioritizationCategory = reactQueryMutationAdapter(
  appSettingsAppGroupIdMessagePrioritizationCategoryCacheKeys,
  (props: PostMessagePrioritizationCategoryProps): Promise<PostMessagePrioritizationCategoryResult> => {
    const body = {
      app_group_id: props.appGroupId,
      new_name: props.newName,
      old_name: props.oldName,
      description: props.description,
    };

    return fetch(`/app_settings/${props.appGroupId}/message_prioritization/category`, "POST", body, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
